import React, { useEffect, useState, useRef } from "react";
// import Zoom from "react-reveal/Zoom";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchRace, STATUSES } from "../redux/getReducer/getCard";
import Cookies from "js-cookie";
import Moment from "react-moment";
import { useTranslation } from "react-i18next";
import Header from "../Components/Reuseable/Header";
import Lottie from "lottie-react";
import Animate from "../assets/loader.json";
import { truncateRaceType } from "../service/stringUtils";
import flag from "../assets/United Arab Emirates.png";

import "../Components/CSS/Scrollbar.css";
import { getRaceStatusColor } from "../service/raceStatusColor";


const TrophyGold = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#d4af37"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ marginRight: "4px" }}
  >
    <path d="M8 21h8M12 17v4M7 4h10M5 4h14v5c0 3.866-3.134 7-7 7s-7-3.134-7-7V4z"></path>
  </svg>
);
const TrophySilver = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#a0a0a0"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ marginRight: "4px" }}
  >
    <path d="M8 21h8M12 17v4M7 4h10M5 4h14v5c0 3.866-3.134 7-7 7s-7-3.134-7-7V4z"></path>
  </svg>
);
const TrophyBronze = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#cd7f32"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ marginRight: "4px" }}
  >
    <path d="M8 21h8M12 17v4M7 4h10M5 4h14v5c0 3.866-3.134 7-7 7s-7-3.134-7-7V4z"></path>
  </svg>
);

const RaceCardDetail = () => {
  const { data: Card, status } = useSelector((state) => state.Card);
  const { id, date } = useParams();
  const location = useLocation();
  const hash = location.hash;

  function binaryToDate(binaryString) {
    if (!binaryString) return null;
    const timestamp = parseInt(binaryString, 2);
    if (isNaN(timestamp)) return null;
    return new Date(timestamp);
  }

  const decodedDate = date ? new Date(date) : binaryToDate(hash.replace("#", ""));


  const dispatch = useDispatch();
  const { t } = useTranslation();
  const cookiedata = Cookies.get("i18next");
  const navigate = useNavigate();

  const myRef = useRef(null);
  useEffect(() => {
    if (myRef.current) {
      myRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  let calenderid = id;
  let calenderdate = decodedDate;
  let datecalender = calenderdate ? new Date(calenderdate) : new Date();
  datecalender.setHours(0, 0, 0);
  const convertedDate = datecalender.toString();

  useEffect(() => {
    if (calenderid && convertedDate && convertedDate !== "Invalid Date") {
      dispatch(fetchRace({ calenderid, convertedDate }));
    }
  }, [calenderid, hash, date, dispatch]);

  const [userIsDesktop, setUserIsDesktop] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      setUserIsDesktop(window.innerWidth > 840);
    };
    window.addEventListener("resize", handleResize);
    handleResize(); // Set initial value
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function HandleJockey(id) {
    navigate(`/race-detail?${id}`);
    setTimeout(() => {
      const scrollY = window.innerWidth <= 530 ? 1300 : 150;
      window.scrollTo({ top: scrollY, behavior: "smooth" });
    }, 500);
  }

  function formatAMPM(date) {
    const DataDate = new Date(date);
    var hours = DataDate.getHours();
    var minutes = DataDate.getMinutes();
    var ampm = hours >= 12 ? t("PM") : t("AM");
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  }

  // Function to convert Hex to RGBA for 50% opacity
  const hexToRgba = (hex, opacity) => {
    if (!hex || !hex.startsWith("#")) return hex;
    let r = parseInt(hex.slice(1, 3), 16);
    let g = parseInt(hex.slice(3, 5), 16);
    let b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };

  return (
    <div ref={myRef}>
      <style>
        {`
          .rcp-today-race-wrapper { 
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; 
          }

          .rcp-top-banner {
            background-color: #0c122e;
            color: white;
            padding: 18px 25px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-radius: 8px;
            margin-bottom: 25px;
            border-left: 6px solid #16a34a;
            position: -webkit-sticky;
            position: sticky;         
            top: 0px;                
            z-index: 100;             
          }

          .rcp-track-left { 
            display: flex; 
            align-items: center; 
            gap: 15px; 
          }
          
          .rcp-track-name { 
            font-size: 20px; 
            font-weight: 800; 
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }
            .rcp-track-Day{
            font-size: 20px; 
            font-weight: 500; 
            letter-spacing: 0.3px;
            }
          
          .rcp-track-flag { 
            width: 22px; 
            height: auto;
            border-radius: 2px;
          }

          .rcp-status-buttons { 
            display: flex; 
            gap: 8px; 
          }
          
          .rcp-status-btn { 
            padding: 5px 12px; 
            border-radius: 5px; 
            font-size: 18px; 
            font-weight: 700; 
            color: white; 
          }
          .rcp-btn-live { background-color: #4db450; }
          .rcp-btn-due { background-color: #f37b21; }
          .rcp-btn-end { background-color: #e62f3a; }
          .rcp-btn-can { background-color: #98409a; }

          .rcp-cards-container {
            display: flex;
            flex-direction: column;
            gap: 18px; /* Margin between cards */
            padding: 0 5px;
            max-height: 530px;
            overflow-y: auto;
          }


          .rcp-card { 
            display: flex; 
            border: 1px solid #e0e6ed; 
            border-radius: 12px; 
            // overflow: hidden; 
            background: #ffffff;
            cursor: pointer; 
            transition: all 0.2s;
            // min-height: 125px;
          }
          
          .rcp-card:hover { 
            box-shadow: 0 4px 15px rgba(0,0,0,0.06); 
            border-color: #cbd5e1;
          }

          .rcp-card-left {
            width: 150px;
            display: flex;
            flex-direction: column;
            color: white;
            flex-shrink: 0;
          }
          
          .rcp-card-left-top {
            flex: 2;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 30px;
            font-weight: 800;
          }
          
          .rcp-card-left-bottom {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 20px;
            font-weight: 800;
          }

          .rcp-card-right {
            flex: 1;
            padding: 16px 24px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            background-color: #f7faff;
          }

          .rcp-row-top {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 12px;
          }
          
          .rcp-desc-text {
            font-size: 20px;
            color: #272727;
            font-weight: 800;
            max-width: 70%;
          }

          .rcp-runners-text {
            font-size: 18px;
            color: #262726;
            font-style: italic;
            font-weight: 700;
          }
          
          .rcp-runners-text strong {
            color: #334155;
            font-style: normal;
          }

          .rcp-row-mid {
            display: grid;
            grid-template-columns: 1fr 1fr 1.5fr 1fr;
            gap: 15px;
            margin-bottom: 15px;
            padding-bottom: 15px;
           }

          .rcp-data-box {
            display: flex;
            flex-direction: column;
            gap: 4px;
          }

          .rcp-data-label {
            font-size: 18px;
            color: #050505;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }

          .rcp-data-value {
            font-size: 18px;
            color: #0f172a;
            font-weight: 600;
          }

          .rcp-row-bot {
            display: flex;
            align-items: center;
            gap: 30px;
            flex-wrap: wrap;
          }

          .rcp-trophy-item {
            display: flex;
            align-items: center;
            font-size: 18px;
            color: #0a0a0a;
            font-weight: 600;
          }

          .rcp-trophy-item span {
            color: #000000;
            margin-left: 8px;
            font-weight: 500;
          }

          @media (max-width: 768px) {
            .rcp-card { flex-direction: column; }
            .rcp-card-left { width: 100%; flex-direction: row; height: 50px; }
            .rcp-row-mid { grid-template-columns: 1fr 1fr; gap: 10px; }
            .rcp-status-buttons { display: none; }
            .rcp-top-banner { justify-content: flex-start; }
            .rcp-desc-text { max-width: 100%; }
          }
        `}
      </style>

      {status !== "loading" ? (
        <div className="RaceCardDetail rcp-today-race-wrapper">
          {Card.length === 0 ? (
            <div className="NAclass">Loading ...</div>
          ) : (
            <div className="RaceCard">
              {Card.map((item) => (
                <React.Fragment key={item.id}>
                  <div className="rcp-top-banner">
                    <div className="rcp-track-left">
                      <span className="rcp-track-name">
                        {cookiedata === "en"
                          ? item.TrackNameEn
                          : item.TrackNameAr}
                      </span>
                      <img src={flag} alt="flag" className="rcp-track-flag" />
                      <span className="rcp-track-Day">
                        {item?.RaceCourseData[0]?.Day && new Date(item.RaceCourseData[0].Day).toLocaleDateString(cookiedata === "en" ? "en-GB" : "ar-AE", {
                          weekday: "long",
                          day: "2-digit",
                          month: "long",
                          year: "numeric",
                        })}
                      </span>
                      {item.RaceCourseData && item.Color && (
                        <span
                          style={{
                            background: item.Color,
                            width: "10px",
                            height: "10px",
                            borderRadius: "50%",
                          }}
                        ></span>
                      )}
                    </div>

                    <div className="rcp-status-buttons">
                      <span className="rcp-status-btn rcp-btn-live">{cookiedata === "en" ? "LIVE" : "مباشر"}</span>
                      <span className="rcp-status-btn rcp-btn-due">{cookiedata === "en" ? "DUE" : "قادم"}</span>
                      <span className="rcp-status-btn rcp-btn-end">{cookiedata === "en" ? "END" : "منتهي"}</span>
                      <span className="rcp-status-btn rcp-btn-can">{cookiedata === "en" ? "CAN" : "ملغي"}</span>
                    </div>
                  </div>

                  {item.RaceCourseData.length === 0 ? (
                    <h6 style={{ textAlign: "center", padding: "20px" }}>
                      {cookiedata === "en" ? "There is No race in this racecourse" : "لا يوجد سباق في هذا المضمار"}
                    </h6>
                  ) : (
                    <div className="rcp-cards-container custom-scrollbar">

                      {item.RaceCourseData.map((data) => {
                        const totalPrize =
                          (data?.FirstPrice || 0) +
                          (data?.SecondPrice || 0) +
                          (data?.ThirdPrice || 0) +
                          (data?.FourthPrice || 0) +
                          (data?.FifthPrice || 0) +
                          (data?.SixthPrice || 0);

                        const groundType =
                          cookiedata === "en"
                            ? data.TrackLengthData?.GroundTypeModelData?.NameEn
                            : data.TrackLengthData?.GroundTypeModelData?.NameAr;

                        const raceType =
                          cookiedata === "en"
                            ? truncateRaceType(data.RaceTypeModelData?.NameEn)
                            : data.RaceTypeModelData?.NameAr;

                        const baseColor = getRaceStatusColor(data.RaceStatus, data);
                        const lightColor = hexToRgba(baseColor, 0.5);

                        return (
                          <div
                            key={data._id}
                            className="rcp-card"
                            onClick={() => HandleJockey(data._id)}
                          >
                            {/* LEFT COLOR SECTION (DYNAMIC) */}
                            <div className="rcp-card-left">
                              <div
                                className="rcp-card-left-top"
                                style={{ backgroundColor: baseColor }}
                              >
                                {t("Race")} {data.RaceNumber}
                              </div>
                              <div
                                className="rcp-card-left-bottom"
                                style={{ backgroundColor: lightColor }}
                              >
                                {formatAMPM(data.StartTime)}
                              </div>
                            </div>

                            {/* RIGHT DATA SECTION */}
                            <div className="rcp-card-right">
                              <div className="rcp-row-top">
                                <div className="rcp-desc-text">
                                  {cookiedata === "en"
                                    ? data.DescriptionEn
                                    : data.DescriptionAr}
                                </div>
                                <div className="rcp-runners-text">
                                  <strong>{data?.Runners || 0}</strong>{" "}
                                  {t("runners")} &nbsp;{" "}
                                  <strong>{data?.NonRunners || 0}</strong>{" "}
                                  {t("NonRunner")}
                                </div>
                              </div>

                              <div className="rcp-row-mid">
                                <div className="rcp-data-box">
                                  <span className="rcp-data-label">
                                    {t("Dist")}
                                  </span>
                                  <span className="rcp-data-value">
                                    {console.log(data.TrackLengthData.TrackLength)}
                                    {data.TrackLengthData?.TrackLength
                                      ? `${data.TrackLengthData.TrackLength}`
                                      : "-dsdssd"}
                                  </span>
                                </div>
                                <div className="rcp-data-box">
                                  <span className="rcp-data-label">
                                    {t("GROUND")}
                                  </span>
                                  <span className="rcp-data-value">
                                    {groundType || "-"}
                                  </span>
                                </div>
                                <div className="rcp-data-box">
                                  <span className="rcp-data-label">
                                    {t("Race Type")}
                                  </span>
                                  <span className="rcp-data-value">
                                    {raceType || "-"}
                                  </span>
                                </div>
                                <div className="rcp-data-box">
                                  <span className="rcp-data-label">
                                    {t("PRIZE")}
                                  </span>
                                  <span className="rcp-data-value">
                                    {t("AED")} {totalPrize.toLocaleString()}
                                  </span>
                                </div>
                              </div>

                              <div className="rcp-row-bot">
                                {data.FirstRankHorseEnglish ||
                                  data.SecondRankHorseEnglish ||
                                  data.ThirdRankHorseEnglish ? (
                                  <>
                                    {data.FirstRankHorseEnglish && (
                                      <div className="rcp-trophy-item">
                                        <TrophyGold /> {t("1st")}{" "}
                                        <span>
                                          {cookiedata === "en"
                                            ? data.FirstRankHorseEnglish
                                            : data.FirstRankHorseArabic}
                                        </span>
                                      </div>
                                    )}
                                    {data.SecondRankHorseEnglish && (
                                      <div className="rcp-trophy-item">
                                        <TrophySilver /> {t("2nd")}{" "}
                                        <span>
                                          {cookiedata === "en"
                                            ? data.SecondRankHorseEnglish
                                            : data.SecondRankHorseArabic}
                                        </span>
                                      </div>
                                    )}
                                    {data.ThirdRankHorseEnglish && (
                                      <div className="rcp-trophy-item">
                                        <TrophyBronze /> {t("3rd")}{" "}
                                        <span>
                                          {cookiedata === "en"
                                            ? data.ThirdRankHorseEnglish
                                            : data.ThirdRankHorseArabic}
                                        </span>
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {data.Favourite1English && (
                                      <div className="rcp-trophy-item">
                                        <TrophyGold /> {t("1st")}{" "}
                                        <span>
                                          {cookiedata === "en"
                                            ? data.Favourite1English
                                            : data.Favourite1Arabic}
                                        </span>
                                      </div>
                                    )}
                                    {data.Favourite2English && (
                                      <div className="rcp-trophy-item">
                                        <TrophySilver /> {t("2nd")}{" "}
                                        <span>
                                          {cookiedata === "en"
                                            ? data.Favourite2English
                                            : data.Favourite2Arabic}
                                        </span>
                                      </div>
                                    )}
                                    {data.Favourite3English && (
                                      <div className="rcp-trophy-item">
                                        <TrophyBronze /> {t("3rd")}{" "}
                                        <span>
                                          {cookiedata === "en"
                                            ? data.Favourite3English
                                            : data.Favourite3Arabic}
                                        </span>
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>
          )}
        </div>
      ) : (
        <h2 className="RaceCardDetail">
          <Lottie animationData={Animate} loop={true} className="TableLottie" />
        </h2>
      )}
    </div>
  );
};

export default RaceCardDetail;
